export const defaultTimeZone = {
  timeZoneId: 97,
  offset: '+07:00',
  timeZoneNameWindows: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  timeZoneName: 'SE Asia Standard Time',
  sortOrder: 97,
}
